module.exports = __webpack_public_path__ + "img/folder-gear.55928a5f.svg";